// extracted by mini-css-extract-plugin
module.exports = {"topNavDesktopBar":"top-nav-desktop-bar_topNavDesktopBar__BcFH8"};